import { render, staticRenderFns } from "./BoutiqueGoods.vue?vue&type=template&id=4c6871d8&scoped=true&"
import script from "./BoutiqueGoods.vue?vue&type=script&lang=js&"
export * from "./BoutiqueGoods.vue?vue&type=script&lang=js&"
import style0 from "./BoutiqueGoods.vue?vue&type=style&index=0&id=4c6871d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6871d8",
  null
  
)

export default component.exports